import styled from "styled-components";
import bgGradient from "./img/bg-gradient.svg";
// import backgroundImage from "./img/background.svg";

// Common font styles
const fontStyles = {
  heavy: `
    font-feature-settings: "liga" off, "clig" off;
    font-family: "Mark For MC Narrow W00 Heavy";
    font-style: normal;
    font-weight: 800;
  `,
  book: `
    font-feature-settings: "liga" off, "clig" off;
    font-family: "Mark For MC Narrow W00 Book";
    font-style: normal;
    font-weight: 400;
  `,
  bookBold: `
    font-feature-settings: "liga" off, "clig" off;
    font-family: "Mark For MC Narrow W00 Book";
    font-style: normal;
    font-weight: 700;
  `
};

// Common colors
const colors = {
  white: "#fff",
  green: "#00d907",
  orange: "#fd661b",
  black: "#000",
  buttonOrange: "rgba(207, 69, 0, 1)"
};

// Common button styles
const buttonBase = `
  padding: 0 16px;
  height: 35px;
  border-radius:9999px;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  
  p {
    margin: 0;
    text-align: center;
    font-size: 14px;
    line-height: 16.79px;
  }
`;

// Common section styles
const sectionBase = `
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const MainContainer = styled.div`
  position: relative;
  z-index: 0;
  max-width: 480px;
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  background-color: ${colors.black};
  overflow: hidden;

  h2 {
    color: ${colors.white};
    ${fontStyles.heavy}
    font-size: 28px;
    line-height: 36px;
    text-align: left;
    width: 100%;
  }

  p {
    color: ${colors.white};
    ${fontStyles.book}
    font-size: 16px;
    line-height: 25px;
  }
`;

export const Separator = styled.img`
  align-self: ${({ left }) => (left ? "flex-start" : "flex-end")};
  margin-left: ${({ left }) => (left ? "-24px" : "auto")};
  margin-right: ${({ right }) => (right ? "-24px" : "auto")};
`;

export const Navbar = styled.div`
  width: 100%;
  position: fixed;
  background-color: ${colors.black};
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;

  img {
    aspect-ratio: 146/45;
    max-width: 146px;
    height: auto;
    margin: 0 auto;
  }
`;

export const WelcomeSection = styled.div`
  ${sectionBase}
  margin-top: 64px;

  img {
    object-fit: contain;
    width: 100%;
    height: auto;
  }

  h1 {
    position: absolute;
    top: 8px;
    right: 8px;
    color: ${colors.white};
    text-align: right;
    ${fontStyles.heavy}
    font-size: 38px;
    line-height: 40px;
    max-width: 287px;
  }

  .caption {
    color: ${colors.white};
    ${fontStyles.book}
    font-size: 12px;
    line-height: 25px;
    position: absolute;
    bottom: 8px;
    right: 8px;
  }
`;

export const IntroSection = styled.div`
  ${sectionBase}
  padding: 20px;
  gap: 20px;
`;

export const PersonalSection = styled.div`
  ${sectionBase}
  padding: 20px;
  gap: 20px;

  .video-container {
    width: 100%;
    video {
      width: 100%;
    }
  }
`;

export const MyJacketSection = styled.div`
  position: relative;
  padding: 16px 22px;
  display: flex;
  flex-direction: column;
  gap: 28px;

  .inner-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    background-image: url(${bgGradient});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 24px;
    border-radius: 12px;
  }

  .jacket-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;

    img {
      width: 240px;
      height: auto;
      object-fit: contain;
      margin-bottom: -32px;
    }
  }

  .details-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 28px;
    img {
      width: 102px;
      height: auto;
      object-fit: contain;
    }
  }

  .details-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  .primary-button {
    ${buttonBase}
    border: 1px solid ${colors.buttonOrange};
    background-color: ${colors.buttonOrange};

    p {
      color: ${colors.white};
      ${fontStyles.book}
    }

    img {
      width: 20px;
      height: auto;
      object-fit: contain;
    }
  }

  .secondary-button {
    ${buttonBase}
    border: 1px solid ${colors.buttonOrange};
    background-color: ${colors.buttonOrange};

    p {
      color: ${colors.white};
      ${fontStyles.heavy}
    }
  }

  .name {
    color: ${colors.white};
    text-align: center;
    ${fontStyles.bookBold}
    font-size: 14px;
    line-height: 26px;
  }
`;

export const PaymentSection = styled.div`
  ${sectionBase}
  padding: 16px 22px;
  gap: 20px;

  h2 {
    text-align: left;
  }

  .intro {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  p {
    text-align: left;
  }

  .bold {
    ${fontStyles.heavy}
  }

  .balance {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .balance-amount {
    ${buttonBase}
    margin: 16px auto 48px;
    height: 56px;
    padding: 0 24px;
    background-image: url(${bgGradient});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    p {
      color: ${colors.white};
      ${fontStyles.heavy}
      font-size: 16px;
      line-height: 24px;
    }
  }
  .bobo-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    width: 100%;

    p {
      color: ${colors.white};
      ${fontStyles.book}
      font-size: 16px;
      line-height: 19px;
    }

    .activation-code {
      border-radius: 6px;
      border: 1px solid #fff;
      background: #141413;
      display: flex;
      flex-direction: row;
      padding: 12px 16px;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;

      p {
        color: ${colors.white};
        ${fontStyles.heavy}
        font-size: 28px;
        line-height: 36px;
      }

      .copy-icon {
        cursor: pointer;
      }
    }
    .join-button {
      ${buttonBase}
      background-color: ${colors.buttonOrange};
      width: auto;
      margin-top: 16px;
      cursor: pointer;
      padding: 0 16px;

      img {
        width: 13.5px;
        height: auto;
        object-fit: contain;
      }

      p {
        color: ${colors.white};
        ${fontStyles.book}
      }
    }
  }

  .bobo-logo {
    width: 147px;
    height: auto;
    object-fit: contain;
  }
`;

export const Footer = styled.div`
  ${sectionBase}
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;

  .digiseq {
    width: 132px;
    height: auto;
    object-fit: contain;
  }

  .paymeswiss {
    width: 152px;
    height: auto;
    object-fit: contain;
  }

  .powered-by {
    ${fontStyles.heavy}
    font-size: 16px;
    line-height: 19px;
  }

  .payment-services {
    ${fontStyles.heavy}
    font-size: 16px;
    line-height: 19px;
  }

  .copyToClipboard {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;
